import { render, staticRenderFns } from "./DispatchDashboard.vue?vue&type=template&id=2bd3a211&scoped=true&"
import script from "./DispatchDashboard.vue?vue&type=script&lang=js&"
export * from "./DispatchDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DispatchDashboard.vue?vue&type=style&index=0&id=2bd3a211&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd3a211",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd3a211')) {
      api.createRecord('2bd3a211', component.options)
    } else {
      api.reload('2bd3a211', component.options)
    }
    module.hot.accept("./DispatchDashboard.vue?vue&type=template&id=2bd3a211&scoped=true&", function () {
      api.rerender('2bd3a211', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DispatchDashboard/DispatchDashboard.vue"
export default component.exports